@if (facetList$ | async; as facetList) {
  <ng-container class="">
    <div class="active-filters">
      @for (facet of facetList?.activeFacets; track facet) {
        <a class="filter-tag"
          routerLink="./" [queryParams]="getLinkParams(facet)"
          [cxFocus]="getFocusKey(facetList, facet)" (click)="linkClick()">
          <span>
            {{
            facet.facetValueName === 'true' || facet.facetValueName === 'false'
            ? facet.facetValueName === 'true'
            ? 'Yes'
            : 'No'
            : facet.facetValueName
            | removeUnderscore}}
            <cx-icon aria-hidden="true" [type]="closeIcon" class="applied-icon d-inline ml-2"></cx-icon></span>
          </a>
        }
      </div>
    </ng-container>
  }
